export const colors = {
  color1: "linear-gradient(to top, #9A6B0E, #C99211)",
  color2: "linear-gradient(to top, #B17F14, #8C6400)",
  color3: "linear-gradient(to top, #C99211, #9A6B0E)",
  color4: "linear-gradient(to top, #B17F14, #C99211)",
  color5: "linear-gradient(to top, #8C6400, #6b4e0a)",
  color6: "linear-gradient(to top, #9A6B0E, #6b4e0a)",
  color7: "linear-gradient(to top, #B17F14, #6b4e0a)",
  color8: "linear-gradient(to top, #C99211, #6b4e0a)",
  color9: "linear-gradient(to top, #8C6400, #6b4e0a)",
};

const microsoftColors = ["#9A6B0E", "#C99211", "#B17F14", "#8C6400", "#6b4e0a"];

export const getColorForMember = (index) => {
  return microsoftColors[index % microsoftColors.length];
};

// theme.js

export const lightTheme = {
  background: "#ffffff",
  cardBackground: "#ffffff",
  textPrimary: "#000000",
  textSecondary: "rgba(0, 0, 0, 0.45)",
  border: "#f0f0f0",
  progressColor: "#B17F14",
  backgroundGradient: "linear-gradient(to right, #FAF8F3, #F6EFDD)",
};

export const darkTheme = {
  background: "#1f1f1f",
  cardBackground: "#2a2a2a",
  textPrimary: "rgba(255, 255, 255, 0.85)",
  textSecondary: "rgba(255, 255, 255, 0.45)",
  border: "#303030",
  progressColor: "#9A6B0E",
  backgroundGradient: "linear-gradient(to right, #1f1f1f, #2a2a2a)",
};
